export default {
  paper: {
    display: 'flex',
    flexDirection: 'column',
  },
  wrapper: (minWidth) => ({
    '& .MuiInputLabel-root[data-shrink="true"]': {
      top: 0,
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '& .MuiAutocomplete-listbox': {
      padding: '4px',
      margin: 0,
    },
    '& .MuiAutocomplete-popper': {
      minWidth,
    },
    '& .MuiAutocomplete-paper': {
      backgroundColor: '#fff',
    },
    '& .MuiPaper-root': {
      boxShadow: 'none',
    },
    '& .MuiAutocomplete-clearIndicator': {
      svg: { width: '14px' },
      color: (theme) => theme.palette.blues.blue600,
      '&:hover': {
        background: 'none',
      },
    },
  }),
  autocomplete: {
    width: '100%',
    '.MuiAutocomplete-popupIndicator': {
      '&:hover': {
        backgroundColor: 'transparent',
      },
      '::after': {
        content: '""',
      },
    },
  },
  selectItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '6px 12px !important',
    cursor: 'pointer',
    transition: 'background-color 0.15s',
    backgroundColor: 'transparent !important',
    borderRadius: '6px',
    marginBottom: '0 !important',
    fontSize: '14px',
    fontWeight: 400,
    color: (theme) => `${theme.palette.text.primary} !important`,
    '&.Mui-focused': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
      span: {
        color: (theme) => `${theme.palette.text.primary} !important`,
      },
    },
    '&[aria-selected="true"]': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
      '&.Mui-focused': {
        backgroundColor: (theme) =>
          `${theme.palette.grays?.gray100} !important`,
        color: (theme) => `${theme.palette.text.primary} !important`,
        span: {
          color: (theme) => `${theme.palette.text.primary} !important`,
        },
      },
    },
    '&:hover': {
      backgroundColor: (theme) => `${theme.palette.grays?.gray100} !important`,
      color: (theme) => `${theme.palette.text.primary} !important`,
    },
  },
  radioIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.blues.primaryBlue500,
  },
  radioUncheckedIcon: {
    fontSize: '16px',
    color: (theme) => theme.palette.grays?.gray300,
  },
  textfield: {
    width: '100%',
    height: '100%',
    fontSize: '0.875rem',
    color: (theme) => theme.palette.blues.primaryBlue,

    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.875rem',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },

    '& .MuiInputBase-root': {
      height: '40px',
      '&:hover': {
        backgroundColor: (theme) => theme.palette.grays.lightestGray,

        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
        },
      },
      '&.Mui-focused': {
        color: (theme) => theme.palette.blues.primaryBlue500,

        '& .MuiOutlinedInput-notchedOutline': {
          borderWidth: 1,
          borderColor: (theme) => theme.palette.blues.blue600,
          border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
        },
      },
    },
  },
  textfieldWithValue: {
    '& .MuiInputBase-input': {
      padding: '10px 12px',
      fontSize: '0.875rem',
      color: (theme) => theme.palette.blues.primaryBlue500,
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
    },
    '& .MuiInputBase-root': {
      height: '40px',
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.blues.blue600}`,
        },
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          border: (theme) => `1px solid ${theme.palette.grays.gray300}`,
        },
      },
    },
  },
};
